<template>
  <ClientTransactionCard></ClientTransactionCard>
</template>

<script>
  import ClientTransactionCard from '@/components/ClientTransactionCard'

  export default {
    name: 'ClientTransaction',
    components: {
      ClientTransactionCard
    },
    mounted () {
      document.getElementById('app__container').scrollTop = 0
    }
  }
</script>
